import { inject } from '@angular/core'
import type { CanActivateFn } from '@angular/router'
import { Router } from '@angular/router'

export const redirectToLoginWithUrl: CanActivateFn = (_, state) => {
  const router = inject(Router)

  const excludedUrls: string[] = ['/next/credits', '/next/thanks']
  const queryParams = excludedUrls.some(url => state.url.startsWith(url)) ? null : { redirect_url: state.url }
  return router.navigate(['/login'], { queryParams })
}
